export default __webpack_public_path__ + "static/media/image.84fd31ef.png";